import { render, staticRenderFns } from "./StorageSpaceAdd.vue?vue&type=template&id=2dc4e87a&"
import script from "./StorageSpaceAdd.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports